import type { AppRouteRecordRaw } from "#src/router/types";

import { IconReader } from "#src/components/iconReader/IconReader";
import ContainerLayout from "#src/layout/container-layout";
import { createElement, lazy } from "react";

const VesselPage = lazy(() => import("#src/features/Vessels"));
const VesselDetailsPage = lazy(() => import("#src/features/Vessels/VesselDetailsPage"));

const routes: AppRouteRecordRaw[] = [
	{
		path: "/vessel",
		Component: ContainerLayout,
		handle: {
			title: "Vessel",
			icon: createElement(IconReader, { name: "vessel" }) as any, // choose an appropriate icon
			order: 2, // adjust order to appear below Ref.Data (which has order 2)
			keepAlive: true,
		},
		children: [
			{
				path: "/vessel/vessel",
				Component: VesselPage,
				handle: {
					title: "Vessel",
				},
			},
			{
				path: "/vessel/vessel/:id/details",
				Component: VesselDetailsPage,
				handle: {
					title: "Vessel Details",
					hideInMenu: true,
				},
			},
		],
	},
];

export default routes;
